import React, {useState} from 'react';
import {useHistory} from "react-router-dom";
import routes from 'globals/routes';
import {useDataValue} from 'globals/contexts/dataContext';

import './switcher.css';
const Switcher = () => {
  const [{currentLanguage, currentPage}, dispatch] = useDataValue();
  const history = useHistory();

  const switcherOnClick = () => {
    
    dispatch({
      type: 'pageTransitionStart',
    });
    setTimeout(() => {
      const nextPage = currentPage? (!currentPage.startsWith("commercial")? "commercial": "index") : "commercial";
      history.push(routes.pageWithLang(nextPage, currentLanguage));
      dispatch({
        type: 'toggleActiveContent',
        // data: newStatus
      });
      // dispatch({
      //   type: 'pageTransitionEnd',
      // });
    }, 1500);
  }
  return <div id="switcher" onClick={switcherOnClick}>
    <div className="switcherText verticalText">
      {currentLanguage === "tc" &&
        <div className="tc">
          {!currentPage || currentPage.startsWith("commercial")? "書法": "商業"}
          作品集
        </div>
      }
      {/* <div className="seperator"></div> */}
      {currentLanguage === "en" && 
        <div className="en">
          Selected {!currentPage || currentPage.startsWith("commercial")? "Art": "Commercial"} Work
        </div>
      }
    </div>
    <img src="./media/switcher.png" />
    <div className="icon"><img src="./media/iconPen.png" /></div>
  </div>;
}

export default Switcher;